const Filter = ({ header, children }) => {
	return (
		<div className="w-favImg lg:w-[261px]  bg-white p-5 lg:p-2 mt-0 lg:mt-3">
			<h1 className="font-bold text-sm">{header}</h1>
			{children}
		</div>
	);
};

export default Filter;
